import { useContext, useEffect, useState } from "react";
import Select from "react-dropdown-select";
import dropdownOptions from "../data/dropdownOptions.json";
import { StoreContext } from "../store/Store";
import { actionTypes } from "../store/storeTypes";

const parentStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: 200,
};

export const SelectCountry = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { menuSelection, mode } = store;
  const selectStyle = { width: 300, marginTop: 10 };
  const [options, setOptions] = useState(null);
  useEffect(() => {
    setOptions(dropdownOptions["countries"]);
  }, []);

  return options && menuSelection === "Select Country" && mode === "layout" ? (
    <div style={parentStyle}>
      <div>
        Select Country
        <div style={selectStyle}>
          <Select
            options={options}
            onChange={(values) => {
              dispatch({
                type: actionTypes.SET_SELECTED_COUNTRY,
                payload: values[0].value,
              });
            }}
          />
        </div>
      </div>
    </div>
  ) : null;
};
